// =======================================
// modules/fvScrollHint.js
// FV 右側の「SCROLL」表示
//
// - 見た目の線アニメーションは CSS 側で担当
// - この JS は「少しスクロールしたらフェードアウト」だけを担当
// - インライン script は使わず、front.js から初期化する
// =======================================

const SELECTOR = ".p-fvSidebar__scrollArea";
const HIDDEN_CLASS = "is-scroll-hidden";

function getHideThreshold() {
  if (typeof window === "undefined") return 80;

  const viewportBased = window.innerHeight * 0.08;
  return Math.min(Math.max(viewportBased, 64), 120);
}

export function initFvScrollHint() {
  const scrollHint = document.querySelector(SELECTOR);
  if (!scrollHint) return;

  let threshold = getHideThreshold();
  let ticking = false;

  const update = () => {
    ticking = false;

    if (window.scrollY > threshold) {
      scrollHint.classList.add(HIDDEN_CLASS);
      return;
    }

    scrollHint.classList.remove(HIDDEN_CLASS);
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  const handleResize = () => {
    threshold = getHideThreshold();
    requestUpdate();
  };

  update();

  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", handleResize, { passive: true });
}
